import { useCallback, useEffect, useState } from "react";
import { httpGet } from "../../../framework";

type ImportantNotesDataType = {
  dId: string;
  dValue: string;
};

const ImportantNotesPage = (props: any) => {
  // const dispatch = useDispatch();
  // const device = useSelector((state: RootState) => state.session.device);
  const [importantNotesData, setImportantNotesData] = useState<
    ImportantNotesDataType[]
  >([]);

  const importantNoteListStyle = {};

  const fetchData = useCallback(async () => {
    const data: any = await httpGet("/api/protected/ptps/getImportantNotes");
    setImportantNotesData(data.value.rows);
  }, []);

  useEffect(() => {
    fetchData().catch(console.error);
  }, [fetchData]);

  // useEffect(() => {
  //   console.log("*****importantNotesData:", importantNotesData);
  // }, [importantNotesData]);

  const importantNotesRendering = () => {
    return importantNotesData.map(
      (data: ImportantNotesDataType, index: number) => {
        const dangerouslyHTML = { __html: data.dValue };
        return (
          <li
            id={`ipn_${index}`}
            style={{
              textAlign: "justify",
              wordBreak: "break-word",
              marginTop: "1rem",
            }}
            dangerouslySetInnerHTML={dangerouslyHTML}
          ></li>
        );
      }
    );
  };

  return (
    <div className={`container static-content`}>
      <ol
        className={`theme-color-bgSlickDot-white-bg`}
        style={importantNoteListStyle}
      >
        {importantNotesRendering()}
      </ol>
    </div>
  );
};

export default ImportantNotesPage;
